import { MarppleCustomDetailF } from '../../../../../modules/Marpple/CustomDetail/F/Function/module/MarppleCustomDetailF.js';

!(function () {
  MarppleCustomDetailF.defnCustomStickerFrame();
})();
